export default "__VITE_ASSET__85339985__"